<template>
  <v-row class="pt-4">
    <v-col cols="2">
      {{ startTime }}
    </v-col>
    <v-col cols="8">
      <v-progress-linear
          :value="percentageOfCompletion"
          buffer-value="100"
          height="25"
          :color="colors.main"
          :background-color="colors.full"
          class="progress-canvas"
      >
        <strong :style="'color: ' + colors.text" v-html="msToHMS(showTime)"/>
      </v-progress-linear>
    </v-col>
    <v-col cols="2">
      {{ endTime }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'time-bar',
  props: [ 'time' ],
  data () {
    return {
      // time: {
      //   startAt: '2022-04-25 12:10:10.42342',
      //   endAt: '2022-04-25 12:16:10.42342',
      //   shouldEndAt: '2022-04-25 12:15:10.42342',
      //   realTime: new Date(),
      // },
      mainColor: 'teal accent-1',
      fullColor: 'red accent-3',
      realTime: null,
    }
  },
  mounted() {
    this.getRealtime()
  },
  computed: {
    fStartTime () {
      return new Date(this.time.started_at)
    },
    fEndTime () {
      return new Date(this.time.finished_at || this.realTime)
    },
    fShouldEndTime () {
      return new Date(this.time.should_be_finished_at)
    },
    startTime () {
      const formTime = new Date(this.time.started_at)
      let h = formTime.getHours();
      h = h < 10 ? "0" + h.toString() : h.toString();
      let m = formTime.getMinutes();
      m = m < 10 ? "0" + m.toString() : m.toString();
      return h + ":" + m;
    },
    endTime () {
      if (this.time.finished_at) {
        const formTime = new Date(this.time.finished_at)
        let h = formTime.getHours();
        h = h < 10 ? "0" + h.toString() : h.toString();
        let m = formTime.getMinutes();
        m = m < 10 ? "0" + m.toString() : m.toString();
        return h + ":" + m;
      } else {
        const formTime = new Date(this.time.should_be_finished_at)
        let h = formTime.getHours();
        h = h < 10 ? "0" + h.toString() : h.toString();
        let m = formTime.getMinutes();
        m = m < 10 ? "0" + m.toString() : m.toString();
        return h + ":" + m;
      }
    },
    colors () {
      if (this.fEndTime > this.fShouldEndTime) {
        return { main: 'red accent-1', full: 'red accent-2', text: 'white' }
      } else {
        if(this.percentageOfCompletion < 60) {
          return { main: 'green accent-2', full: 'white', text: 'black' }
        } else {
          return { main: 'orange accent-2', full: 'white', text: 'black' }
        }
      }
    },
    showTime () {
      if (this.fEndTime > this.fShouldEndTime) {
        return this.fullTime
      } else {
        return this.spentTime
      }
    },
    fullTime () {
      if (this.fEndTime > this.fShouldEndTime) {
        return this.fEndTime - this.fStartTime
      } else {
        return this.fShouldEndTime - this.fStartTime
      }
    },
    spentTime () {
      if (this.fEndTime < this.fShouldEndTime) {
        return this.fEndTime - this.fStartTime
      } else {
        return this.fShouldEndTime - this.fStartTime
      }
    },
    percentageOfCompletion () {
      return parseInt((this.spentTime / this.fullTime) * 100)
    },
  },
  methods: {
    getRealtime () {
      this.realTime = new Date()
      setTimeout(() => this.getRealtime(), 1000)
    },
    msToHMS( ms ) {
      // 1- Convert to seconds:
      let seconds = ms / 1000
      // 2- Extract hours:
      let hours = parseInt( seconds / 3600 ) // 3,600 seconds in 1 hour
      seconds = seconds % 3600 // seconds remaining after extracting hours
      // 3- Extract minutes:
      let minutes = parseInt( seconds / 60 ) // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = parseInt(seconds % 60)
      if (hours) {
        if ( hours < 10) { hours = '0' + hours }
        if ( minutes < 10) { minutes = '0' + minutes }
        if ( seconds < 10) { seconds = '0' + seconds }
        return hours + ':' + minutes + ':' + seconds
      } else if (minutes) {
        if ( minutes < 10) { minutes = '0' + minutes }
        if ( seconds < 10) { seconds = '0' + seconds }
        return '00:' + minutes + ':' + seconds
      } else {
        if ( seconds < 10) { seconds = '0' + seconds }
        return  '00:00:' + seconds
      }

    }
  }
}

</script>

<style>
.progress-canvas {
  box-shadow: 0 0 2px black;
}
</style>